import React from 'react';
import {FormattedMessage} from 'react-intl';

import classnames from 'classnames';

import {PencilIcon} from '@time-webkit/all/icons/pencil';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import styles from './styles.module.css';

export type Props = {
    typingUsers: string[];
}

const getTypingText = (typingUsers: string[]) => {
    const users = [...typingUsers];

    if (users.length === 0) {
        return '';
    }
    if (users.length === 1) {
        return (
            <FormattedMessage
                id='msg_typing.isTyping'
                defaultMessage='{user} is typing'
                values={{
                    user: users[0],
                }}
            />
        );
    }
    const last = users.pop();
    return (
        <FormattedMessage
            id='msg_typing.areTyping'
            defaultMessage='{users} and {last} are typing'
            values={{
                users: (users.join(', ')),
                last,
            }}
        />
    );
};

export const MsgTyping = ({typingUsers}: Props) => {
    const bodyM = useTypography({size: TypographySize.BodyM});

    const text = getTypingText(typingUsers);

    if (!text) {
        return null;
    }

    return (
        <div
            className={classnames(styles.container, bodyM)}
        >
            <PencilIcon width={12} height={12}/>
            {text}
        </div>
    );
};
